import { GridColumn } from 'src/components/GridWrapper';
import VarianceCell from 'src/sections/variance_details/VarianceCell';
import AccountingPeriodWarningCell from 'src/sections/variance_details/variance-design-cells/AccountingPeriodWaringCell';
import VarianceColumnsCell from 'src/sections/variance_details/variance-design-cells/VarianceColumnsCell';
import VarianceHeaderCell from 'src/sections/variance_details/variance-design-cells/VarianceHeaderCell';

import VariancePeriodColumnsCell from 'src/sections/variance_details/variance-design-cells/VariancePeriodColumnsCell';
import VariancePeriodHeaderCell from 'src/sections/variance_details/variance-design-cells/VariancePeriodHeaderCell';
export const validateNumber = (field: string, value: any) => {
  if (Number(value[field]) < 0) {
    return { color: '#94C947' };
  } else if (Number(value[field]) > 0) {
    return {
      color: '#D9534F',
      backgroundColor: 'rgba(217, 170, 79, 0.2)',
    };
  }
  return {};
};

export const quantityVarianceStyle = (field: string, dataItem: any) => {
  const value = dataItem[field];
  if (Number(value) < 0) {
    return { color: '#94C947' };
  } else if (Number(value) > 0) {
    return {
      color: '#D9534F',
      backgroundColor: 'rgba(217, 170, 79, 0.2)',
    };
  } else if (
    Number(value) === 0 &&
    ((field === 'poQtyVariance' && dataItem.hasQtyVariance) ||
      (field === 'poSubTotalVariance' && dataItem.hasSubTotalVariance))
  ) {
    return {
      backgroundColor: ' #3FA9DB33',
    };
  }

  return {};
};

export const VarianceLineItemColumns: GridColumn<any>[] = [
  {
    field: 'expanded',
    width: 45,
    menu: false,
    sortable: false,
    headerCell: VarianceHeaderCell,
    component: VarianceColumnsCell,
    minResizableWidth: 45,
  },
  {
    field: 'number',
    title: '',
    menu: false,
    width: 395,
    minResizableWidth: 250,
  },
  {
    field: 'itemNumber',
    title: 'Item #',
    filter: 'text',
    dataType: 'string',
    width: 100,
    minResizableWidth: 90,
  },
  {
    field: 'glCd',
    title: 'GL Code',
    filter: 'text',
    dataType: 'string',
    width: 110,
    minResizableWidth: 100,
    component: VarianceCell('hasGlCodeVariance'),
  },
  {
    field: 'poQty',
    title: 'Total PO Qty',
    dataType: 'number',
    filter: 'numeric',
    format: '{0:n2}',
    width: 110,
    minResizableWidth: 100,
  },
  {
    field: 'invoicedQuantity',
    title: 'Doc Total Qty',
    filter: 'numeric',
    dataType: 'number',
    format: '{0:n2}',
    width: 110,
    minResizableWidth: 100,
  },
  {
    field: 'poQtyVariance',
    title: 'Qty Var',
    filter: 'numeric',
    dataType: 'number',
    format: '{0:n2}',
    width: 110,
    minResizableWidth: 100,
    specificStyle: quantityVarianceStyle,
  },
  {
    field: 'poUom',
    title: 'PO UOM',
    filter: 'text',
    dataType: 'string',
    width: 110,
    minResizableWidth: 100,
    component: VarianceCell('hasUOMVariance'),
  },
  {
    field: 'poPrice',
    title: 'PO Price',
    filter: 'numeric',
    dataType: 'dollar',
    format: '{0:c2}',
    width: 110,
    minResizableWidth: 100,
    filterFormat: 'c2',
  },
  {
    field: 'poSubTotal',
    title: 'PO Total Subtotal',
    filter: 'numeric',
    dataType: 'dollar',
    format: '{0:c2}',
    width: 110,
    minResizableWidth: 100,
    filterFormat: 'c2',
  },
  {
    field: 'invoicedSubTotal',
    title: 'Docs Total Subtotal',
    filter: 'numeric',
    dataType: 'dollar',
    format: '{0:c2}',
    width: 120,
    minResizableWidth: 100,
    filterFormat: 'c2',
  },
  {
    field: 'poSubTotalVariance',
    title: '$ Var',
    filter: 'numeric',
    dataType: 'dollar',
    format: '{0:c2}',
    filterFormat: 'c2',
    specificStyle: quantityVarianceStyle,
    minResizableWidth: 100,
    width: 120,
  },
];

export const VariancePeriodColumns: GridColumn<any>[] = [
  {
    field: 'expanded',
    width: 45,
    menu: false,
    sortable: false,
    headerCell: VariancePeriodHeaderCell,
    component: VariancePeriodColumnsCell,
    minResizableWidth: 45,
  },
  {
    field: 'acctPeriod',
    title: 'Accounting Period',
    menu: false,
    component: AccountingPeriodWarningCell,
    width: 350,
    minResizableWidth: 250,
  },
  {
    field: 'itemNumber',
    title: '',
    menu: false,
    width: 100,
  },
  {
    field: 'poGlCdDescription',
    title: '',
    component: VarianceCell('hasGlCodeVariance'),
    menu: false,
    width: 110,
  },
  {
    field: 'periodPoQty',
    title: 'Period PO Qty',
    dataType: 'number',
    format: '{0:n2}',
    width: 110,
    minResizableWidth: 100,
    component: VarianceCell('hasQtyVariance'),
    menu: false,
  },
  {
    field: 'periodDocQty',
    title: 'Total Docs Period Qty',
    dataType: 'number',
    format: '{0:n2}',
    minResizableWidth: 100,
    width: 110,
    component: VarianceCell('hasQtyVariance'),
    menu: false,
  },
  {
    field: 'periodQtyVariance',
    title: 'Period Qty Var',
    dataType: 'number',
    format: '{0:n2}',
    minResizableWidth: 100,
    width: 110,
    specificStyle: validateNumber,
    menu: false,
  },
  {
    field: 'poUom',
    title: '',
    width: 110,
    component: VarianceCell('hasUOMVariance'),
    menu: false,
  },
  {
    field: 'poPrice',
    title: '',
    width: 110,
    menu: false,
  },
  {
    field: 'periodPoSubTotal',
    title: 'PO Period Subtotal',
    dataType: 'dollar',
    format: '{0:c2}',
    component: VarianceCell('hasSubTotalVariance'),
    minResizableWidth: 100,
    width: 110,
    menu: false,
  },
  {
    field: 'periodDocSubTotal',
    title: 'Docs Period Total Subtotal',
    dataType: 'dollar',
    format: '{0:c2}',
    component: VarianceCell('hasSubTotalVariance'),
    minResizableWidth: 100,
    width: 120,
    menu: false,
  },
  {
    field: 'periodSubtotalVariance',
    title: 'Period $ Var',
    dataType: 'dollar',
    format: '{0:c2}',
    specificStyle: validateNumber,
    menu: false,
    minResizableWidth: 100,
    width: 120,
  },
];

export const subVarianceLineItems: GridColumn<any>[] = [
  {
    field: 'documentType',
    title: 'Doc type #',
    menu: false,
    minResizableWidth: 120,
    width: 162,
  },

  {
    field: 'documentNumber',
    title: 'Doc #',
    menu: false,
    minResizableWidth: 120,
    width: 163,
  },
  {
    field: 'itemNumber',
    title: '',
    width: 100,
    menu: false,
  },
  {
    field: 'glCode',
    title: 'GL Code',
    minResizableWidth: 100,
    width: 110,
    menu: false,
    component: VarianceCell('hasGlCodeVariance'),
  },
  {
    field: 'number',
    title: '',
    width: 110,
    menu: false,
  },
  {
    field: 'quantity',
    title: 'Doc Qty',
    dataType: 'number',
    format: '{0:n2}',
    minResizableWidth: 90,
    width: 110,
    menu: false,
  },
  {
    field: 'number',
    title: '',
    width: 110,
    menu: false,
  },
  {
    field: 'uom',
    title: 'Doc UOM',
    dataType: 'string',
    minResizableWidth: 90,
    width: 110,
    menu: false,
    component: VarianceCell('hasUOMVariance'),
  },
  {
    field: 'price',
    title: 'Doc Price',
    minResizableWidth: 90,
    width: 110,
    dataType: 'dollar',
    format: '{0:c2}',
    menu: false,
  },
  {
    field: 'number',
    title: '',
    width: 110,
    menu: false,
  },
  {
    field: 'invoiceSubtotal',
    title: 'Doc Subtotal',
    minResizableWidth: 90,
    width: 120,
    dataType: 'dollar',
    format: '{0:c2}',
    menu: false,
  },
  {
    field: 'number',
    title: '',
    menu: false,
    width: 120,
  },
];
